import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./iitBombayTechfest.css";
import { ROBOTICS_IMAGE, MESSAGE, SUCCESS_IMAGE } from '../../../constant';
import TextInputField from '../../commanComponents/textInputField/textInputField';
import BaseNavbar from '../../commanComponents/navbar/baseNavbar';
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import { saveIITBombayFestService } from '../../../modules/services';


const IITBombayTechfest = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessSection, setShowSuccessSection] = useState(false);

    const loginSchema = z.object({
        //first_name
        first_name: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "First Name") }),
        //last_name
        last_name: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Last Name") }),
        //email
        email: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Email") }).email({ message: MESSAGE.EMAIL_INVALID }),
        //dob
        phone: z.string(),
        //Institution Name
        comments: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Institution Name") }),
    });
    
    const { register, handleSubmit, control, formState: { errors }, getValues } = useForm({
        resolver: zodResolver(loginSchema)
    });

    const handleCompetetionSubmission = (data) => {
        setIsLoading(true);
        (async () => {
            const responseData = await saveIITBombayFestService(data, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setIsLoading(false);
                setShowSuccessSection(true);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                console.log(responseData);
            }
            else {
                window.location.href = "https://fizrobotics.com/";
            }
        })();
    }

    return (
        <>
            <BaseNavbar />
            <div className='row main-row'>
                {
                    !showSuccessSection
                    ?
                    <>
                        <div className='col iit-bombay-left-img-div'>
                            <img
                                src={ROBOTICS_IMAGE}
                                alt='ai_robot'
                                className='robot_img'
                            />
                        </div>
                        <div className='col'>
                            <div className='nef-main-div'>
                                <div className='nef-form-div'>
                                    <Form onSubmit={handleSubmit(handleCompetetionSubmission)}>
                                        <Form.Label className='heading'>
                                            IIT Bombay Competition
                                        </Form.Label>
                                        <Form.Label className='sub-heading'>
                                            FIZ Robotic Solutions Presents
                                        </Form.Label>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="First name"
                                                    fieldType="text"
                                                    errorMessage={errors.first_name?.message}
                                                    inputKey="first_name"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Last name"
                                                    fieldType="text"
                                                    errorMessage={errors.last_name?.message}
                                                    inputKey="last_name"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Email"
                                                    fieldType="text"
                                                    errorMessage={errors.email?.message}
                                                    inputKey="email"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Phone Number"
                                                    fieldType="text"
                                                    errorMessage={errors.phone?.message}
                                                    inputKey="phone"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='row add-mentor-input-row'>
                                            <div className='col-sm'>
                                                <TextInputField
                                                    placeholder="Institution Name"
                                                    fieldType="text"
                                                    errorMessage={errors.comments?.message}
                                                    inputKey="comments"
                                                    maxWidth="400px"
                                                    formRegister={register}
                                                />
                                            </div>
                                        </div>
                                        <div className='submit-button-div' style={{marginTop: "40px"}}>
                                            <PrimaryButton
                                                text="SUBMIT"
                                                type={"submit"}
                                                isLoading={isLoading}
                                                customStyle={{height: "40px"}}
                                            />
                                        </div>
                                        <Form.Label className='nef-bottom-description'>
                                            <b>Note:</b> In case of any query, feel free to contact contact@fizrobotics.com
                                        </Form.Label>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div style={{textAlign: "center", paddingTop: "5%"}}>
                            <label className='heading' style={{marginBottom: "1%"}}>
                                Resgitration Saved Successfully.
                            </label>
                            <label className='sub-heading' style={{marginBottom: "2%"}}>
                                Our team will contact you for further details.
                            </label>
                            <img 
                                src={SUCCESS_IMAGE}
                                alt='ai_robot'
                                className='success-image'
                            />
                        </div>
                    </>
                }
                
            </div>
        </>
    );
}

export default IITBombayTechfest;
